var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9168 5.16634C8.63662 5.16634 5.16683 8.63613 5.16683 12.9163C5.16683 17.1965 8.63662 20.6663 12.9168 20.6663C17.197 20.6663 20.6668 17.1965 20.6668 12.9163C20.6668 8.63613 17.197 5.16634 12.9168 5.16634ZM2.5835 12.9163C2.5835 7.2094 7.20989 2.58301 12.9168 2.58301C18.6238 2.58301 23.2502 7.2094 23.2502 12.9163C23.2502 18.6233 18.6238 23.2497 12.9168 23.2497C7.20989 23.2497 2.5835 18.6233 2.5835 12.9163Z",
    fill: "#697B7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4378 12.9167C17.4378 10.4199 15.4138 8.39583 12.917 8.39583V5.8125C16.8405 5.8125 20.0212 8.99314 20.0212 12.9167H17.4378Z",
    fill: "#697B7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2886 18.4609L28.0386 26.2109L26.2119 28.0376L18.4619 20.2876L20.2886 18.4609Z",
    fill: "#697B7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-icon.07789feef1397b99b9d8326bf1ebaef0.svg";